<p-dialog [style]="{width: '80vw'}" [(visible)]="isVisible" appendTo="body" (visibleChange)="dialogVisibleChange($event)" [modal]="true" [resizable]="false" [draggable]="false">
  <p-header>{{ 'FSCSSCImport.Header' | translate }}</p-header>
  <div class="mt-2">
    <form class="detail-form" [formGroup]="importForm">
      <div class="p-fluid formgrid grid">
        <div class="field grid col-4 align-items-baseline">
          <label class="col-2 column-label">{{ 'FSCSSCImport.Search.Forwarder' | translate }}</label>
          <div class="col-10 column-value">
            <p-dropdown formControlName="forwarder" [filter]="true" [options]="forwarderOptions" [(ngModel)]="forwarder" placeholder="{{ 'Common.Message.ChooseOption' | translate }}"></p-dropdown>
            <small
              *ngIf="((submitted || importForm.controls.forwarder.touched) && importForm.controls.forwarder.errors?.required)" class="p-invalid">{{ 'Common.Button.Required' | translate }}
            </small>
          </div>
        </div>
      </div>
    </form>
    <h4>{{ 'FSCSSCImport.Search.File' | translate }}</h4>
    <div class="container">
      <div class="formgrid grid">
          <div class="field col-12">
            <p-fileUpload #fileUpload [customUpload]="true" (uploadHandler)="fileUploader($event)" chooseLabel="{{ 'FSCSSCImport.Button.Select' | translate }}" uploadLabel="{{ 'FSCSSCImport.Button.Import' | translate }}" cancelLabel="{{ 'FSCSSCImport.Button.Cancel' | translate }}" accept=".xls,.xlsx">
              <ng-template pTemplate="toolbar">
                <button pButton pRipple label="{{ 'FSCSSCImport.Button.TemplateDownload' | translate }}" (click)="templateDownloadClickBtn($event)" class="ml-2"></button>
              </ng-template>
            </p-fileUpload>
          </div>
      </div>
    </div>
    <div class="mt-2">
      <laas-data-table [tableKey]="preferenceKey" [selectable]="false" [dataKey]="'seqNo'" [value]="airwaysExpenseRows" [defaultColumns]="columns" [loading]="isLoading">
        <ng-template pTemplate="caption">
          <button pButton pRipple label="{{ 'FSCSSCImport.Button.Upload' | translate }}" [disabled]="airwaysExpenseRows.length === 0" (click)="importClickBtn($event)" class="ml-2"></button>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <td *ngFor="let col of columns">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchDefault>
                <div [ngSwitch]="col.dataType">
                  <ng-container *ngSwitchCase="'date'">
                    <div class="overflow-text">
                      {{ rowData[col.field] | date:'yyyy-MM-dd':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <div class="overflow-text">
                      {{ rowData[col.field] | replaceNullWith:'-'}}
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </td>
        </ng-template>
      </laas-data-table>
    </div>
  </div>
</p-dialog>
